// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__+dEqd","title":"ErrorBoundary_title__arO+S","message":"ErrorBoundary_message__udB1m","button":"ErrorBoundary_button__LIqf0"};